import React from "react";
import { useTranslation } from "react-i18next";
import { View, SafeAreaView } from "react-native";

import Logo from "@/assets/logo.svg";
import RejectedImage from "@/assets/rejected.svg";
import Copyright from "@/components/Copyright";
import Title from "@/components/Title";
import ButtonLogout from "@/components/button/ButtonLogout";

export default function Rejected() {
  const { t } = useTranslation();

  return (
    <SafeAreaView className="grow bg-white1">
      <View className="z-50 absolute top-0 right-0 m-8">
        <ButtonLogout />
      </View>
      <View className="items-center justify-center w-full h-full">
        <View className="items-center h-5/6 w-full">
          <Logo className="m-2" />
          <View className="m-2">
            <Title text={t("onboarding/rejected:title")} />
          </View>
          <View className="m-4">
            <RejectedImage width={300} height={300} />
          </View>
          <Title text={t("onboarding/rejected:instructions")} />
        </View>
        <View className="flex-grow justify-end items-end h-1/6">
          <Copyright />
        </View>
      </View>
    </SafeAreaView>
  );
}
